var _excluded = ["width", "height", "roundness"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { applySkeletonGradient, applyRoundness } from '../../mixins';
import { DEFAULT_ROUNDNESS } from './Skeleton';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Skeleton/RectSkeleton');
var StyledRectSkeleton = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-10viy0i-0"
})(["", ";", ";position:relative;overflow:hidden;", ""], applyRoundness, applySkeletonGradient, function (_ref) {
  var $width = _ref.$width,
      $height = _ref.$height;
  return css(["width:", ";height:", ";"], $width, $height);
});

/**
 * Компонент для создания прямоугольного плейсхолдера.
 */
export var RectSkeleton = function RectSkeleton(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      _ref2$roundness = _ref2.roundness,
      roundness = _ref2$roundness === void 0 ? DEFAULT_ROUNDNESS : _ref2$roundness,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledRectSkeleton, _extends({
    $width: typeof width === 'string' ? width : "".concat(width, "px"),
    $height: typeof height === 'string' ? height : "".concat(height, "px"),
    roundness: roundness
  }, rest));
};